
/**
 *	Stellt ALLEN Components Methode bereit.
 * 
 *	Einbindung in main.js über:
 * 
 *	import PreloadPlugin from './plugins/preload'
 *	Vue.use( PreloadPlugin );
 *
 */

export default {
	install (Vue, options) {	

		Vue.prototype.preloadImages = function ( images ) {

			return new Promise(function(resolve, reject) {
				var isSingle = typeof images == 'string';
				if (isSingle) images = [images];
				
				var total = images.length;

				images.forEach(( src, n ) => {
					var img = new Image();
					images[n] = {src:src, img:img, error:false};
					img.onload = () => imageResult.apply( images[n], [true] );
					img.onerror = () => imageResult.apply( images[n], [false] );
					img.src = src;
				});

				function imageResult( success ) {
					Object.assign(this, {
						error: !success,
						width: this.img.width,
						height: this.img.height,
					});
					total--;
					if (total == 0) {
						resolve(isSingle ? images.pop() : images);
					}
				}

			});
		}

	}
}